import React, { useEffect, useCallback, useState } from 'react'

// redux
import { connect } from 'react-redux'

// bootstrap
import { Modal } from 'react-bootstrap'

// icons : feather
import FeatherIcon from 'feather-icons-react';

// stripe payment
import StripePayment from './includes/StripePayment';

// actions
import { setGlobalLoading } from 'redux/actions/actionCommon';

// api
import { chargeOrderPaymentApi } from 'utlis/Apis/Cart_API';

// toast
import { toast } from 'react-toastify'

// app messages
import {
    ERROR_WHILE__NAME,
    UNKNOWN_ERROR_OCCURED
} from 'utlis/AppMessages/AppMessages'

function TakePaymentModal(props) {
    // props
    const {
        authState,
        currentOrderId,
        modalVisibility,
        closeModal,

        totalAmount,
        commonToken,
        setGlobalLoading
    } = props

    const [stripeTokenRecieved, setStripeTokenRecieved] = useState(null)

    const confirmPayment = () => {
        if (stripeTokenRecieved && currentOrderId) {
            // global loading
            setGlobalLoading(true)

            // data required
            const requiredData = {
                order_id: currentOrderId,
                stripe_token: stripeTokenRecieved
            }

            const headers = {
                "Authorization": `Bearer ${authState.commonToken}`,
                "Api-Token": authState.apiToken,
                "Access-Token": "",
                // "Store-Id": authState.storeId,
            }

            // network request
            chargeOrderPaymentApi(headers, requiredData).then(res => {
                const resData = res.data

                // global loading
                setGlobalLoading(false)

                // if success
                if (resData.success) {
                    closeModal && closeModal() // closing the modal

                    // dismissing all the previous toasts first
                    toast.dismiss();

                    // showing the error message
                    toast.success(resData.message, {
                        autoClose: 2500,
                        onClose: () => {
                            window.location.reload() // reloading the windows
                        }
                    });
                }

                // if error
                if (resData.error) {
                    // dismissing all the previous toasts first
                    toast.dismiss();

                    // showing the error message
                    toast.error(resData?.message ?? UNKNOWN_ERROR_OCCURED, {
                        autoClose: 2500
                    });
                }

            }).catch(err => {
                console.log(`${ERROR_WHILE__NAME} chargeOrderPaymentApi `, err.message);

                // dismissing all the previous toasts first
                toast.dismiss();

                // showing the error message
                toast.error(UNKNOWN_ERROR_OCCURED, {
                    autoClose: 2500,
                    onClose: () => {
                        // global loading
                        setGlobalLoading(false)
                    },
                });
            })
        }
    }

    useEffect(() => {
        if (stripeTokenRecieved && currentOrderId) {
            confirmPayment()
        }
    }, [stripeTokenRecieved, currentOrderId])


    // calling function when stripe toke is available
    // useEffect(() => {
    //     console.log("stripeTokenRecieved ", stripeTokenRecieved);
    //     console.log("currentOrderId ", currentOrderId);

    //     if (stripeTokenRecieved && currentOrderId) {
    //         confirmPayment()
    //     }
    // }, [
    //     stripeTokenRecieved,
    //     currentOrderId,
    //     confirmPayment
    // ])

    return (
        <Modal
            show={modalVisibility}
            onHide={closeModal}
            centered
            // size={"lg"}
            className="st-info-modal">
            <Modal.Body className="st-modal">
                {/* close icon */}
                <div className="app-modal-content modal_compelte-payment position-relative pt-0" style={{ minHeight: 'auto' }}>
                    <button
                        className="close-icon position-absolute st-round-btn st-btn-sm st-btn-white d-flex align-items-center justify-content-center"
                        onClick={closeModal}
                        style={{ top: 0, right: 0 }}>
                        <FeatherIcon
                            icon="x"
                            size="20"
                            className="icon position-relative" />
                    </button>


                    {/* head */}
                    <div className="app-modal-title-wrapper mb-3">
                        <p className="app-modal-title mb-2">Take Payment</p>
                        <p className="desc">Take the payment on the user's behalf and complete it</p>
                    </div>

                    {/* details */}
                    <div className="details mb-3">
                        <p className="d-flex st-fs-18">
                            <span className="head">Total amount to pay:</span>
                            <span className="amount ms-auto st-text-primary st-fw-600">{totalAmount}</span>
                        </p>
                    </div>


                    {/* payment form */}
                    <StripePayment
                        totalAmount={totalAmount}

                        setStripeTokenRecieved={setStripeTokenRecieved}
                    />

                </div>
            </Modal.Body>
        </Modal>
    )
}


const getDataFromStore = state => {
    return {
        authState: state.auth,
        commonToken: state.auth.commonToken,
    };
}

const dispatchActionsToProps = dispatch => {
    return {
        setGlobalLoading: bool => dispatch(setGlobalLoading(bool)),
    }
}

export default connect(getDataFromStore, dispatchActionsToProps)(TakePaymentModal)